import {
  LIST_ALERTS_MANAGEMENT,
  useAlertsManagementListFilter,
  useAlertsManagementListOrder,
  useCurrentWorkspace,
} from '@gripp/shared-logic';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InfiniteDataGrid } from '../infiniteDataGrid';
import { useColumns } from './useColumns';

export type AlertsManagementListProps = {
  maxHeight?: number;
  paddingBottom?: number;
  preserveScrollKey?: string;
};

export const AlertsManagementList = ({
  maxHeight,
  paddingBottom,
  preserveScrollKey,
}: AlertsManagementListProps) => {
  const { t } = useTranslation();

  const { data } = useAlertsManagementListFilter();
  const { data: orderData } = useAlertsManagementListOrder();
  const workspace = useCurrentWorkspace(true);

  const [filter, setFilter] = useState<any>(undefined);
  const [columns, setColumns] = useState<string[]>([]);

  useEffect(() => {
    if (!data || workspace === undefined) return;
    setColumns(data.columns || []);
    
    const f = { ...data };
    f.workspaceId = workspace?.id;
    if (f.keyword === '') delete f.keyword;
    delete f.columns;
    setFilter(f);
  }, [data, workspace]);

  const columnsWithFilter = useColumns({ ...filter, columns }) as ColumnDef<any, any>[];

  return !filter ? null : (
    <InfiniteDataGrid
      modelName="workflow"
      query={LIST_ALERTS_MANAGEMENT}
      orderBy={orderData}
      filter={filter}
      pageSize={50}
      columns={columnsWithFilter}
      listMaxHeight={maxHeight as number}
      paddingBottom={paddingBottom as number}
      textEmpty={t('alertsManagement.common.textEmpty')}
      dataPrefix="workflow.listAlerts"
      enableScrollRefresh={true}
      preserveScrollKey={preserveScrollKey}
      showScrollIndicator={true}
      exportFileName="alerts"
    />
  );
};
